import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const ChevronLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.543 19.207 7.336 12l7.207-7.207 1.414 1.414L10.164 12l5.793 5.793z"
      className="primary"
    />
  </svg>
);
export default withCustomIcon(ChevronLeftIcon);
